function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var EmptyPanelTemplate = require('./empty-panel.template');
var EmptyPanel = /*#__PURE__*/function () {
  function EmptyPanel(app, mod) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, EmptyPanel);
    this.app = app;
    this.mod = mod;
    this.container = '';
    this.title = options.title || '';
    this.body = options.body || '';
    this.actionLabel = options.actionLabel || '';
    this.action = options.action || 'sell';
    this.onAction = options.onAction || null;
  }
  return _createClass(EmptyPanel, [{
    key: "render",
    value: function render() {
      var _this = this;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!this.container) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(EmptyPanelTemplate({
        title: this.title,
        body: this.body,
        actionLabel: this.actionLabel,
        action: this.action
      }), this.container);
      var btn = document.querySelector("".concat(this.container, " [data-action]"));
      if (btn && typeof this.onAction === 'function') {
        btn.onclick = function (e) {
          e.preventDefault();
          _this.onAction();
        };
      }
    }
  }]);
}();
module.exports = EmptyPanel;